import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicStorageModule } from '@ionic/storage';
import { HttpClientModule } from '@angular/common/http';
import { BrMaskerModule } from 'br-mask';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { Navigation } from 'src/pages/navigation/navigation';
import { LoginPage } from "src/pages/login/login.page";
import { EsqueciMinhaSenhaPage } from 'src/pages/esqueci-minha-senha/esqueci-minha-senha.page'
import { SplashPage } from 'src/pages/splash/splash.page'
import { CadastroPage } from 'src/pages/cadastro/cadastro.page'
import { NotificacoesPage } from 'src/pages/navigation/configuracoes/notificacoes/notificacoes.page'
import { AlterarSenhaPage } from 'src/pages/navigation/configuracoes/alterar-senha/alterar-senha.page'
import { DetalhesAtivoPage } from 'src/pages/navigation/recomendacoes/detalhes-ativo/detalhes-ativo.page'
import { GraficoPage } from 'src/pages/grafico-ativo/grafico.page'
import { ContratacaoPage } from 'src/pages/contratacao/contratacao.page'
import { AvaliacaoPage } from 'src/pages/avaliacao/avaliacao.page'
import { BoasVindasDialog } from 'src/pages/navigation/home/boas-vindas/boas-vindas.dialog'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlanoDialog } from 'src/pages/plano/plano.dialog';
import { FormularioTrader } from 'src/pages/formulario-trader/formulario-trader.page';
import { Resultado } from 'src/pages/formulario-trader/resultado/resultado.page';
import { PlanoIosPage } from 'src/pages/plano-ios/PlanoIosPage';
import { CarteiraRecomendadaAlteracaoPage } from 'src/pages/CarteiraRecomendada/CarteiraRecomendadaDetalhe/CarteiraRecomendadaAlteracao/CarteiraRecomendadaAlteracaoPage';
import { CarteiraRecomendadaSimuladorPage } from 'src/pages/CarteiraRecomendada/CarteiraRecomendadaDetalhe/CarteiraRecomendadaSimulador/CarteiraRecomendadaSimuladorPage';
import { SanitizePipe } from './pipes/sanitize.pipe';
import { SortablejsModule } from 'ngx-sortablejs';
import { OnboardingPage } from 'src/pages/onboarding/onboarding.page';
import ptBr from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { WebViewPage } from 'src/pages/webview/webview.page';
import { ClientProspectPage } from 'src/pages/client-prospect/client-prospect.page';
import { ClientProspectComponent } from 'projects/client-prospect/src/public-api';
import { ErrorGenericPage } from 'src/pages/errorGeneric/error-generic.page';
registerLocaleData(ptBr);

@NgModule({
  declarations: [
    AppComponent,
    Navigation,
    LoginPage,
    EsqueciMinhaSenhaPage,
    ClientProspectPage,
    SplashPage,
    CadastroPage,
    NotificacoesPage,
    AlterarSenhaPage,
    DetalhesAtivoPage,
    GraficoPage,
    ContratacaoPage,
    AvaliacaoPage,    
    FormularioTrader,
    Resultado,
    OnboardingPage,
    BoasVindasDialog,
    PlanoDialog,
    PlanoIosPage,
    CarteiraRecomendadaAlteracaoPage,
    CarteiraRecomendadaSimuladorPage,
    SanitizePipe,
    WebViewPage,
    ClientProspectComponent,
    ErrorGenericPage
  ],
  schemas: [NO_ERRORS_SCHEMA],
  entryComponents: [
    BoasVindasDialog,
    PlanoDialog
  ],
  imports: [
    BrowserModule, 
    IonicModule.forRoot({
      backButtonText: '',
      scrollAssist: false
    }), 
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    IonicStorageModule.forRoot({
      name: 'phicube_db',
      driverOrder: ['indexeddb', 'sqlite', 'websql']
    }),
    BrMaskerModule,
    ReactiveFormsModule,
    SortablejsModule.forRoot({ animation: 150 }),
  ],
  providers: [
    InAppPurchase2,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: 'pt-PT' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
